import { useEffect } from "react";
import { site } from "../data/site";

export function usePageMeta(title?: string, description?: string) {
  useEffect(() => {
    const defaultTitle = site.title;
    const defaultDescription = site.description;

    document.title = title ? `${title} | ${site.name}` : defaultTitle;

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", description || defaultDescription);
    } else {
      const meta = document.createElement("meta");
      meta.name = "description";
      meta.content = description || defaultDescription;
      document.head.appendChild(meta);
    }
  }, [title, description]);
}
